import { UserUtil } from './../../core/user-util';
import { environment } from './../../../environments/environment';
import { CsiHttp } from './../../core/csi-http';
import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';


interface EnviaQtdMsg {
  enviaQtdMsg: any
}

@Injectable()
export class AvisosService {

  enviaQtdMsg: EnviaQtdMsg;
  quantidade: any;
  _enviaQtdMsg:EventEmitter<EnviaQtdMsg>  = new EventEmitter<EnviaQtdMsg>();

  constructor(private http: CsiHttp) { }

  apiPrincipal: string = environment.principalAPI;
  apiAtendimentoURL: string = environment.atendimento;



  atualizaContador(enviaQtdMsg ) {
    if(enviaQtdMsg != false){
    this._enviaQtdMsg.emit({
      enviaQtdMsg
    });
    } else{
      this._enviaQtdMsg.emit({
        enviaQtdMsg 
      });
    }
  }

  consultaAvisoDiaList () {
    let url = this.apiPrincipal + '/consultaAvisoDiaList';
    return this.http.getIgnore(url).map((response: any) => {
      return response;
    });
  }

  updateMsgLida (aviso) {
    let url = this.apiPrincipal + '/updateMensagemLida';
    aviso.cdUnidPolicialRead = UserUtil.usuarioLogado.unidPolicial.unidadePolicialPK.cdUnidPolicial;
    return this.http.post(url, aviso).map((response: any) => {
      return response;
    });
  }

  consultaMensagem(cdAviso: number) {
    let url = this.apiPrincipal + '/dadosComum/consultaMensagens';
    url += '?cdAviso=' + cdAviso;
    return this.http.getIgnore(url).map((response: any) => {
      return response;
    });
  }

  retornaQtdAvisos() {
    let url = this.apiPrincipal + '/retornaQtdAvisos';
    return this.http.getIgnore(url).map((response: any) => {
      return response;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/avisos.service.ts